module.exports = __webpack_public_path__ + "static/media/giftcard.a310052e.JPG";